import { Modal } from '@/components/Modal'
import { Content } from './Content'
import { modalId } from '../modalId'
import { ContextProvider } from './ContextProvider'
import { ModalPublicProps } from '../types'

export function Root(props: ModalPublicProps) {
  return (
    <Modal modalId={modalId}>
      <ContextProvider {...props}>
        <Content />
      </ContextProvider>
    </Modal>
  )
}
